import { SourceCRS } from '../../reslink/dtt/addHotel.types';
import { PropertyAddress } from '../../search/searchProperty.types';
import { PropertyBasicInfo } from '../getEventListPlanner.types';
import { ContactNumber } from '../getEventSummaryById.types';

export type GetEventSummaryByIdDttResponse = {
  hotelOperations: {
    groupManagement: {
      roomingListEventById: {
        title: string;
        property: Property;
        groupEvent: {
          groupBlock: {
            sourceCRS: SourceCRS;
            groupContract: GroupContract;
            products: Product[];
          };
          inventoryStatistics: InventoryStatistics;
        };
      };
    };
  };
};

type Property = {
  basicInformation: PropertyBasicInfo;
  contactInformation: {
    contactNumbers: ContactNumber[];
    address: PropertyAddress;
  };
};

export type GroupContract = {
  code: string;
  timespans: TimeSpan[];
  releaseInventory: {
    releaseInfo: {
      date: string;
    };
  };
  derivedFields?: {
    isHousingProtected: boolean;
  };
  pricePlans: {
    priceGridDetails: {
      amountRules: AmountRule[];
    };
  }[];
};

type TimeSpan = {
  start: string;
  end: string;
};

export type AmountRule = {
  timespan?: TimeSpan;
  inventoryTypes: InventoryType[];
};

export enum RateModeCode {
  BASE_RATE = 'BASE_RATE',
  BASE_RATE_DOUBLE = 'BASE_RATE_DOUBLE',
}

export enum ComputationType {
  FLAT = 'FLAT',
  AMOUNT_ADD = 'AMOUNT_ADD',
  AMOUNT_OFF = 'AMOUNT_OFF',
  PERCENT_ADD = 'PERCENT_ADD',
  PERCENT_OFF = 'PERCENT_OFF',
  BUY_AND_GET = 'BUY_AND_GET',
  FLEXIBLE = 'FLEXIBLE',
}

export type InventoryType = {
  code: string;
  ratePlanCode: string;
  rateModeCode: RateModeCode;
  computationTypeEnum: ComputationType;
  amountValue: {
    value: number;
    currencyCode: string;
    numberOfDecimals: number;
  };
};

export type Product = {
  inventoryTypeCode: string;
  roomTypeDetails: {
    name?: string;
    maxOccupancy?: number;
    description?: string;
  };
};

export type InventoryStatistics = {
  groupByGroupPeriods: GroupByGroupPeriod[];
  groupByProductPeriods: GroupByProductPeriod[];
};

export type GroupByGroupPeriod = {
  period: {
    start: string;
    end: string;
  };
  groups: {
    code: string;
    inventoryTypeCounters: {
      allocatedRoomsCounters: number[];
      availabilityCounters: number[];
      bookingCounters: number[];
    };
  }[];
};

export type GroupByProductPeriod = {
  groupByProducts: {
    products: {
      code: string;
      productCounters: {
        allocatedRoomsCounters: number[];
        availabilityCounters: number[];
        bookingCounters: number[];
      };
    }[];
  }[];
};
